module.exports = __webpack_public_path__ + "assets/img/3_1324_big.853dd657.jpg";